
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class ChartMixin extends Vue {
  @Prop({ required: true, default: null }) result!: any;

  @Prop({ required: false, default: null }) propStationId?: string;

  get basinId() {
    return this['$store'].getters.basinId;
  }

  get stationId() {
    return this.propStationId ?? this['$store'].getters.stationId;
  }

  get targetTime() {
    return this['$store'].getters.formatTargetTime;
  }

  get yskSpan() {
    return this['$store'].getters.yskSpan;
  }

  public chartData: any = {
    datasets: [],
    labels: [],
  };
}
